import React, {h, Component} from 'preact';
import GoogleDocsIframe from './GoogleDocsIframe';
import {AutomatchRealtors} from './AutomatchRealtors';
import './edit-property.scss';
import TagsInput from '../TagsInput';
import SellPropertyForm from './SellPropertyForm';
import BuyPropertyForm from './BuyPropertyForm';

export default class EditProperty extends Component {
    state = {
        'editingRequestInfo': false,
        'alsoBuying': '',
        'ownerNotOccupied': false,
        'submitting': false,
        'firstTimeBuyer': false,
        'updatedRequest': null,
        'req.tagLine': '',
        'alsoBuyRejectReason': '',
        alsoBuyingAnswers: {
            alreadyBoughtHome: '',
            buyingLocally: '',
            buyingImmediately: '',
            buildingNewHome: ''
        }
    };

    form;
    updatedRequest;

    onAnswer = (field, val) => {
        this.setState({[field]: '' + val});
    };

    componentDidMount() {
        const {
            alsoBuying,
            ownerNotOccupied,
            firstTimeBuyer,
            sellingAlso,
            exclusiveContract,
            tagLine,
            alsoBuyRejectReason
        } = this.props.reqObj;
        this.setState({
            alsoBuying,
            ownerNotOccupied,
            firstTimeBuyer,
            sellingAlso,
            exclusiveContract,
            alsoBuyRejectReason,
            'req.tagLine': tagLine
        });
        $(this.form).validate();
    }

    saveProperty = () => {
        if (!$(this.form).valid()) {
            return;
        }

        this.setState({submitting: true});
        const serializedForm = $(this.form).serializeArray();
        const formData = {};

        serializedForm.forEach(({name, value}) => (formData[name] = value));

        $.post(this.props.isBuy ? 'update-buyrequest-json' : 'updateRequest-json', formData)
            .then(data => {
                if (checkAjax(data)) {
                    this.updatedRequest = {
                        ...((data || {}).req || data),
                        suggestedRealtors: this.props.reqObj.suggestedRealtors
                    };
                }
                this.setState({editingRequestInfo: false, updatedRequest: this.updatedRequest});
            })
            .always(() => this.setState({submitting: false}));
    };

    handleFormSubmit = e => {
        $(this.form).submit();
    };

    render() {
        let {reqObj, isBuy} = this.props;
        const {
            editingRequestInfo,
            alsoBuying,
            ownerNotOccupied,
            submitting,
            sellingAlso,
            firstTimeBuyer,
            exclusiveContract,
            updatedRequest,
            alsoBuyRejectReason,
        } = this.state;

        reqObj = updatedRequest || reqObj;
        const {
            requestId,
            prop,
            tagLine,
            agentPreference,
            agentComment,
            awardedDate,
            owner,
            competingAgents,
            firstInvitedDate,
            googleTracking,
            tag,
            lowRange,
            lowZestimateStr,
            highRange,
            highZestimateStr,
            zestimate,
            valueForZeroZestimateStr,
            suggestedRealtors,
            expectedListDate,
            roundedZestimateStr,
            user
        } = reqObj;

        return (
            <div className="edit-property-page col-sm-12">
                <div className="col-sm-3">
                    <div className="call-client-container">
                        <div
                            className={`btn orange rounded`}
                            onClick={() => {
                                adminPhone.showOutboundCallPopup({
                                    requestId,
                                    isBuyer: isBuy,
                                    service: 'twilio',
                                    popupTopOffset: $('.header').offset().top + $('.header').outerHeight()
                                });
                                ajaxThis('sms');
                            }}>
                            Call {user.name}
                        </div>
                    </div>
                    <GoogleDocsIframe googleTracking={googleTracking} tag={tag} isBuy={isBuy} />
                </div>
                <div className="col-sm-6 main-content">
                    <form
                        ref={el => (this.form = el)}
                        id="uploadForm"
                        action={isBuy ? 'updateBuyRequest' : 'updateRequest'}
                        method="POST"
                        encType="multipart/form-data">
                        <div style="display:none;">
                            <input type="hidden" name="requestId" value={requestId} />
                            <input type="hidden" id="tempFileName" name="tempFileName" value="" />
                            <input type="hidden" id="deletePhoto" name="deletePhoto" value="false" />
                            <input type="hidden" id="photoWidth" value="800" />
                            <input type="hidden" id="photoHeight" value="600" />
                            {!isBuy && [
                                <input type="hidden" id="mapLatitude" name="mapLatitude" value="" />,
                                <input type="hidden" id="mapLongitude" name="mapLongitude" value="" />,
                                <input type="hidden" id="mapParam" name="mapParam" value="" />,
                                (prop || {}).mapParam ? (
                                    <input
                                        type="hidden"
                                        id="mapChangeParam"
                                        name="mapChangeParam"
                                        value={`h=310&amp;w=100%&amp;lat=${prop.mapLatitude}&amp;lon=${prop.mapLongitude}&amp;${prop.mapParam}&amp;fullAddr=${prop.address} ${prop.zip}`}
                                    />
                                ) : (
                                    <input
                                        type="hidden"
                                        id="mapChangeParam"
                                        name="mapChangeParam"
                                        value={`h=310&amp;w=100%&amp;lat=${prop.mapLatitude}&amp;lon=${prop.mapLongitude}&amp;fullAddr=${prop.address} ${prop.zip}`}
                                    />
                                ),
                                <input type="hidden" id="position_cell" name="position_cell" value="" />,
                                <input type="hidden" id="heading_cell" name="heading_cell" value="" />,
                                <input type="hidden" id="pitch_cell" name="pitch_cell" value="" />,
                                <input type="hidden" id="pano_cell" name="pano_cell" value="" />
                            ]}
                        </div>

                        <div className="row">
                            <div className="breadcrumbs">
                                <a href="/re/listRequest">All Requests</a>
                                <span className="divider"> {'>'} </span>
                                <a href={isBuy ? '/re/list-buyer-request' : '/re/listRequest'}>
                                    {isBuy ? 'Buyers' : 'Sellers'}
                                </a>
                                <span className="divider"> {'>'} </span>
                                <span>{user.name}</span>
                            </div>
                            <div className={`property-attributes ${editingRequestInfo ? 'hidden' : ''}`}>
                                <div className="property-form-title">
                                    {!isBuy ? (
                                        <h3 className="property-address">
                                            {prop.address}, {prop.city}, {prop.state}{' '}
                                            {prop.zillowUrl && (
                                                <a href={prop.zillowUrl} className="zillow-link" target="_blank">
                                                    <i className="icon-brand-zillow" />
                                                </a>
                                            )}
                                        </h3>
                                    ) : (
                                        <h3 className="property-address">
                                            {reqObj.city}, {reqObj.state}
                                        </h3>
                                    )}
                                    <span
                                        className="btn blue outline rounded edit-req-button"
                                        onClick={() =>
                                            this.setState({
                                                editingRequestInfo: true
                                            })
                                        }>
                                        Edit Request Info
                                    </span>
                                </div>
                                {isBuy ? (
                                    <div>
                                        <span className="attribute">{reqObj.propertyType}</span>
                                        <span className="attribute">{reqObj.priceRangeStr}</span>
                                        <span className="attribute">{reqObj.buyerStageCountToStr}</span>
                                        <span className="attribute">{reqObj.buyerFinancingStr}</span>
                                    </div>
                                ) : (
                                    <div>
                                        <span className="attribute">
                                            <i className="icon-house text-blue" /> {prop.homeTypeStr}
                                        </span>
                                        <span className="attribute">
                                            <i className="icon-bath text-blue" /> {prop.baths} Baths
                                        </span>
                                        <span className="attribute">
                                            <i className="icon-bed text-blue" /> {prop.beds} Beds
                                        </span>
                                        {(lowZestimateStr && highZestimateStr) || roundedZestimateStr ? (
                                            <span className="attribute">
                                                <i className="icon-brand-zillow text-blue" />{' '}
                                                {roundedZestimateStr
                                                    ? roundedZestimateStr
                                                    : lowZestimateStr + ' - ' + highZestimateStr}
                                            </span>
                                        ) : (
                                            <span className="attribute">
                                                <i className="icon-brand-zillow text-blue" />{' '}
                                                <input className="zestimate-input" type="number" name="req.zestimate" />
                                            </span>
                                        )}
                                        <span className="attribute bubbletip" title="UpNest Estimated Price">
                                            <i className="icon-currency text-blue" /> {valueForZeroZestimateStr}
                                        </span>
                                        <span className="attribute">
                                            Has title{' '}
                                            <i
                                                className={
                                                    owner ? 'icon-nav-check text-green' : 'icon-nav-close text-red'
                                                }
                                            />
                                        </span>
                                    </div>
                                )}
                            </div>

                            {!isBuy ? (
                                <SellPropertyForm
                                    editingRequestInfo={editingRequestInfo}
                                    prop={prop}
                                    lowRange={lowRange}
                                    highRange={highRange}
                                    submitting={submitting}
                                    highZestimate={zestimate}
                                    owner={owner}
                                    onAnswer={this.onAnswer}
                                    saveProperty={this.saveProperty}
                                />
                            ) : (
                                <BuyPropertyForm
                                    editingRequestInfo={editingRequestInfo}
                                    submitting={submitting}
                                    saveProperty={this.saveProperty}
                                    onAnswer={this.onAnswer}
                                    {...reqObj}
                                />
                            )}

                            <div className="col-xs-12 client-form card">
                                {!isBuy && [
                                    <div className="property-form-rows">
                                        <div className="col-sm-6 form-group">
                                            <label>How soon are you selling?</label>
                                        </div>
                                        <div className="col-sm-6 form-group text-right">
                                            <input
                                                type="text"
                                                name="req.expectedListDate"
                                                className="date forminput form-control"
                                                placeholder="Please select a date"
                                                value={moment(
                                                    this.state['req.expectedListDate'] || expectedListDate
                                                ).format('YYYY-MM-DD')}
                                                onChange={({target: {value}}) =>
                                                    this.onAnswer('req.expectedListDate', value)
                                                }
                                            />
                                        </div>
                                    </div>,
                                    <div className="property-form-rows">
                                        <div className="col-sm-6 form-group">
                                            <label>Working with a Realtor?</label>
                                        </div>
                                        <div className="col-sm-6 form-group">
                                            <input
                                                type="text"
                                                name="req.competingAgents"
                                                className="form-control"
                                                value={this.state['req.competingAgents'] || competingAgents}
                                                placeholder="Enter Agent's Name and Brokerage"
                                                onChange={({target: {value}}) =>
                                                    this.onAnswer('req.competingAgents', value)
                                                }
                                            />
                                        </div>
                                    </div>,
                                    <div
                                        className={`property-form-rows also-buy-question${
                                            '' + alsoBuying === 'true' ? ' no-border' : ''
                                        }`}>
                                        <div className="col-sm-6 form-group">
                                            <label>Also buying another property?</label>
                                            <a
                                                className="h6 txt-info also-buy-create bubbletip"
                                                title="Only create new alsoBuy request when seller is also buying outside the same area"
                                                href="javascript:void(0)"
                                                onClick={() => createAlsoBuyRequest(requestId)}>
                                                {' '}
                                                Create Outside AlsoBuy
                                            </a>
                                        </div>
                                        <div className="col-sm-6 form-group">
                                            <input type="hidden" id="qrequstId" value={requestId}/>
                                            <input type="hidden" name="alsoBuying" value={alsoBuying}/>
                                            <input type="hidden" name="alsoBuyingAnswers.alreadyBoughtHome" value={this.state['alsoBuyingAnswers.alreadyBoughtHome']}/>
                                            <input type="hidden" name="alsoBuyingAnswers.buyingLocally" value={this.state['alsoBuyingAnswers.buyingLocally']}/>
                                            <input type="hidden" name="alsoBuyingAnswers.buyingImmediately" value={this.state['alsoBuyingAnswers.buyingImmediately']}/>
                                            <input type="hidden" name="alsoBuyingAnswers.buildingNewHome" value={this.state['alsoBuyingAnswers.buildingNewHome']}/>

                                            <div className="question-answer-container">
                                                <div
                                                    className={`answer-button yes${
                                                        '' + alsoBuying === 'true' ? ' active' : ''
                                                    }`}
                                                    onClick={() => {
                                                        this.setState({
                                                            alsoBuyRejectReason: '',
                                                            alsoBuyRejectReasonOther: false
                                                        });
                                                        this.onAnswer('alsoBuying', true);
                                                    }}>
                                                    Yes
                                                </div>
                                                <div
                                                    className={`answer-button no${
                                                        '' + alsoBuying === 'false' ? ' active' : ''
                                                    }`}
                                                    onClick={() => {
                                                        this.setState(prevState => {
                                                            let alsoBuyingAnswers = Object.assign({}, prevState.alsoBuyingAnswers);
                                                            alsoBuyingAnswers.alreadyBoughtHome = '';
                                                            alsoBuyingAnswers.buyingLocally = '';
                                                            alsoBuyingAnswers.buyingImmediately = '';
                                                            alsoBuyingAnswers.buildingNewHome = '';
                                                            return {alsoBuyingAnswers};
                                                        });
                                                        this.onAnswer('alsoBuying', false);
                                                    }}>
                                                    No
                                                </div>
                                            </div>
                                            {'' + alsoBuying === 'false' && (
                                                <div
                                                    className="dropdown form-control"
                                                    style="background-color: rgb(255, 255, 255); cursor: default; pointer-events: auto;">
                                                    <input
                                                        type="hidden"
                                                        name="alsoBuyRejectReason"
                                                        value={alsoBuyRejectReason}
                                                    />
                                                    <div className="dropdown-toggle" data-toggle="dropdown">
                                                        <div className="selected-value">
                                                            {this.state.alsoBuyRejectReasonOther
                                                                ? 'Other'
                                                                : alsoBuyRejectReason || 'Select a reason'}
                                                        </div>
                                                        <i className="arrow fa fa-caret-down" />
                                                    </div>
                                                    <div className="dropdown-menu">
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason: 'I am moving out of the area.'
                                                                })
                                                            }>
                                                            I am moving out of the area.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason: 'I am working with a builder.'
                                                                })
                                                            }>
                                                            I am working with a builder.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason:
                                                                        'I don’t need to buy a new home.'
                                                                })
                                                            }>
                                                            I don’t need to buy a new home.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason: 'I have another buyer’s agent.'
                                                                })
                                                            }>
                                                            I have another buyer’s agent.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason:
                                                                        'I need to sell my house first.'
                                                                })
                                                            }>
                                                            I need to sell my house first.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason:
                                                                        'I don’t like working with my listing agent, I need other recommendations.'
                                                                })
                                                            }>
                                                            I don’t like working with my listing agent, I need other
                                                            recommendations.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReason:
                                                                        'I am using my employer’s relocation service.'
                                                                })
                                                            }>
                                                            I am using my employer’s relocation service.
                                                        </li>
                                                        <li role="separator" className="divider" />
                                                        <li
                                                            className="item"
                                                            onClick={() =>
                                                                this.setState({
                                                                    alsoBuyRejectReasonOther: true,
                                                                    alsoBuyRejectReason: ''
                                                                })
                                                            }>
                                                            Other.
                                                        </li>
                                                    </div>
                                                </div>
                                            )}

                                            {'' + alsoBuying === 'false' && this.state.alsoBuyRejectReasonOther && (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name=""
                                                    value={this.state['alsoBuyRejectReason']}
                                                    placeholder="Type the reason"
                                                    onKeyUp={({target: {value}}) =>
                                                        this.onAnswer('alsoBuyRejectReason', value)
                                                    }
                                                />
                                            )}
                                            {'' + alsoBuying === 'false' && reqObj.alsoBuyRejectReason && (
                                                <div className="clients-answer">Pre-filled by client’s answer</div>
                                            )}
                                            <a className="h6 txt-info also-buy-view" href=" " target="_blank">
                                                {' '}
                                            </a>
                                        </div>
                                    </div>,
                                    '' + alsoBuying === 'true' ? (
                                        <div className="property-form-rows sub-row">
                                            <div className="col-sm-6 form-group">
                                                <label>Have you already bought a home?</label>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="question-answer-container">
                                                    <div
                                                        className={`answer-button yes${
                                                            '' + this.state['alsoBuyingAnswers.alreadyBoughtHome'] === 'true' ? ' active' : ''
                                                        }`}
                                                        onClick={() => {
                                                            this.onAnswer('alsoBuyingAnswers.alreadyBoughtHome', true);
                                                        }}>
                                                        Yes
                                                    </div>
                                                    <div
                                                        className={`answer-button no${
                                                            '' + this.state['alsoBuyingAnswers.alreadyBoughtHome'] === 'false' ? ' active' : ''
                                                        }`}
                                                        onClick={() => this.onAnswer('alsoBuyingAnswers.alreadyBoughtHome', false)}>
                                                        No
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null,
                                    '' + alsoBuying === 'true' ? (
                                        <div className="property-form-rows sub-row">
                                            <div className="col-sm-6 form-group">
                                                <label>Are you buying locally?</label>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="question-answer-container">
                                                    <div
                                                        className={`answer-button yes${
                                                            '' + this.state['alsoBuyingAnswers.buyingLocally'] === 'true' ? ' active' : ''
                                                        }`}
                                                        onClick={() => {
                                                            this.onAnswer('alsoBuyingAnswers.buyingLocally', true);
                                                        }}>
                                                        Yes
                                                    </div>
                                                    <div
                                                        className={`answer-button no${
                                                            '' + this.state['alsoBuyingAnswers.buyingLocally'] === 'false' ? ' active' : ''
                                                        }`}
                                                        onClick={() => this.onAnswer('alsoBuyingAnswers.buyingLocally', false)}>
                                                        No
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null,
                                    '' + alsoBuying === 'true' ? (
                                        <div className="property-form-rows sub-row">
                                            <div className="col-sm-6 form-group">
                                                <label>
                                                    Would you be buying a home immediately once you have sold your
                                                    current home?
                                                </label>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="question-answer-container">
                                                    <div
                                                        className={`answer-button yes${
                                                            '' + this.state['alsoBuyingAnswers.buyingImmediately'] === 'true' ? ' active' : ''
                                                        }`}
                                                        onClick={() => {
                                                            this.onAnswer('alsoBuyingAnswers.buyingImmediately', true);
                                                        }}>
                                                        Yes
                                                    </div>
                                                    <div
                                                        className={`answer-button no${
                                                            '' + this.state['alsoBuyingAnswers.buyingImmediately'] === 'false' ? ' active' : ''
                                                        }`}
                                                        onClick={() => this.onAnswer('alsoBuyingAnswers.buyingImmediately', false)}>
                                                        No
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null,
                                    '' + alsoBuying === 'true' ? (
                                        <div className="property-form-rows sub-row">
                                            <div className="col-sm-6 form-group">
                                                <label>
                                                    Are you working with a Builder to build your new home instead of
                                                    purchasing a pre-built home?
                                                </label>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="question-answer-container">
                                                    <div
                                                        className={`answer-button yes${
                                                            '' + this.state['alsoBuyingAnswers.buildingNewHome'] === 'true' ? ' active' : ''
                                                        }`}
                                                        onClick={() => {
                                                            this.onAnswer('alsoBuyingAnswers.buildingNewHome', true);
                                                        }}>
                                                        Yes
                                                    </div>
                                                    <div
                                                        className={`answer-button no${
                                                            '' + this.state['alsoBuyingAnswers.buildingNewHome'] === 'false' ? ' active' : ''
                                                        }`}
                                                        onClick={() => this.onAnswer('alsoBuyingAnswers.buildingNewHome', false)}>
                                                        No
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null,
                                    <div className="property-form-rows">
                                        <div className="col-md-6 form-group">
                                            <label>Do you live in the property?</label>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input type="hidden" name="ownerNotOccupied" value={ownerNotOccupied} />
                                            <div className="question-answer-container">
                                                <div
                                                    className={`answer-button yes${
                                                        '' + ownerNotOccupied === 'false' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('alsoBuyingAnswers.ownerNotOccupied', false)}>
                                                    Yes
                                                </div>
                                                <div
                                                    className={`answer-button no${
                                                        '' + ownerNotOccupied === 'true' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('alsoBuyingAnswers.ownerNotOccupied', true)}>
                                                    No
                                                </div>
                                            </div>
                                        </div>
                                    </div>,

                                    <div className="property-form-rows">
                                        <div className="col-md-6 form-group">
                                            <label>What&apos;s important to you in a realtor?</label>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <TagsInput
                                                placeholder="Good commission rates, experience..."
                                                options={agentPreference}
                                                limit={2}
                                                name="agentPreference"
                                            />
                                        </div>
                                    </div>
                                ]}
                                <div className="property-form-rows">
                                    <div className="col-xs-6 form-group">
                                        <label>Highlights on the {isBuy ? 'Buyer' : 'Seller'} </label>
                                    </div>
                                    <div className="col-xs-6 form-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="req.tagLine"
                                            value={this.state['req.tagLine']}
                                            maxLength="90"
                                            placeholder="(eg. Seller is also looking to buy or seller is commission sensitive.)"
                                            onKeyUp={({target: {value}}) => this.onAnswer('req.tagLine', value)}
                                        />
                                    </div>
                                </div>

                                {isBuy && [
                                    <div className="property-form-rows">
                                        <div className="col-md-6 form-group">
                                            <label>Expected Purchase Date</label>
                                            <input
                                                type="text"
                                                name="expectedBuyingDate"
                                                className="date forminput form-control required"
                                                value={moment(
                                                    this.state.expectedBuyingDate || reqObj.expectedBuyingDate
                                                ).format('YYYY-MM-DD')}
                                                placeholder="Please select a date"
                                                onChange={({target: {value}}) =>
                                                    this.onAnswer('expectedBuyingDate', value)
                                                }
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input type="hidden" name="firstTimeBuyer" value={firstTimeBuyer} />
                                            <label>First-Time Buyer?</label>
                                            <div className="question-answer-container">
                                                <div
                                                    className={`answer-button yes${
                                                        '' + firstTimeBuyer === 'true' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('firstTimeBuyer', true)}>
                                                    Yes
                                                </div>
                                                <div
                                                    className={`answer-button no${
                                                        '' + firstTimeBuyer === 'false' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('firstTimeBuyer', false)}>
                                                    No
                                                </div>
                                            </div>
                                        </div>
                                    </div>,
                                    <div className="property-form-rows">
                                        <div className="col-md-6 form-group">
                                            <input type="hidden" name="sellingAlso" value={sellingAlso} />
                                            <label>Also selling a home?</label>
                                            <div className="question-answer-container">
                                                <div
                                                    className={`answer-button yes${
                                                        '' + sellingAlso === 'true' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('sellingAlso', true)}>
                                                    Yes
                                                </div>
                                                <div
                                                    className={`answer-button no${
                                                        '' + sellingAlso === 'false' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('sellingAlso', false)}>
                                                    No
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input type="hidden" name="exclusiveContract" value={exclusiveContract} />
                                            <label>Exclusive agreement?</label>
                                            <div className="question-answer-container">
                                                <div
                                                    className={`answer-button yes${
                                                        '' + exclusiveContract === 'true' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('exclusiveContract', true)}>
                                                    Yes
                                                </div>
                                                <div
                                                    className={`answer-button no${
                                                        '' + exclusiveContract === 'false' ? ' active' : ''
                                                    }`}
                                                    onClick={() => this.onAnswer('exclusiveContract', false)}>
                                                    No
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ]}

                                <div className="property-form-rows">
                                    <div className="col-xs-8 form-group">
                                        <label>
                                            Edit Note for Agents{' '}
                                            <span style="font-weight:normal;">
                                                (<span class="agentCommentCount">{(agentComment || '').length}</span>
                                                /200 max character length)
                                            </span>
                                        </label>
                                    </div>
                                    <div className="col-xs-4 form-group" style="display:inline; float:right;">
                                        <select
                                            // id='note-for-agent-template-dropdown'
                                            className="form-control custom-select valid template-dropdown"
                                            onChange={({target: {value}}) => {
                                                if (value) {
                                                    this.onAnswer(
                                                        'req.agentComment',
                                                        window.noteForAgentTemplates[value]
                                                    );
                                                }
                                            }}>
                                            <option>Choose a Template</option>
                                            {!isBuy && [
                                                <option value="ready-to-list-template">Ready to List</option>,
                                                <option value="still-doing-research">Still Doing Research</option>,
                                                <option value="currently-listed">Currently Listed</option>,
                                                <option value="fsbo">FSBO</option>
                                            ]}
                                            {isBuy && <option value="buyer-default">Buyer Default</option>}
                                        </select>
                                        <i className="fa fa-caret-down template-dropdown-arrow" />
                                    </div>
                                    <div className="col-xs-12 form-group full-width">
                                        <textarea
                                            rows="8"
                                            name="req.agentComment"
                                            value={this.state['req.agentComment'] || agentComment}
                                            onChange={({target: {value}}) => this.onAnswer('req.agentComment', value)}
                                            className="form-control custom-textarea"
                                            data-gramm="false"
                                            data-gramm_editor="false"
                                            data-enable-grammarly="false"
                                        />
                                    </div>
                                </div>

                                <div className="actions-container clearfix">
                                    <a
                                        id="submitform"
                                        href="javascript:;"
                                        rel="#photoProgress"
                                        className={`btn orange rounded ${submitting ? 'saving' : ''}`}
                                        onClick={this.handleFormSubmit}>
                                        Save Changes
                                    </a>

                                    {!awardedDate && (
                                        <a
                                            id="save-and-auto-match"
                                            className={`btn orange rounded outline ${submitting ? 'saving' : ''}`}
                                            onClick={() => {
                                                $(this.form)
                                                    .attr(
                                                        'action',
                                                        isBuy ? 'updateBuyRequestAndMatch' : 'updateRequestAndMatch'
                                                    )
                                                    .submit();
                                            }}>
                                            {firstInvitedDate ? 'Save & Auto-match' : 'Save & Auto-Invite'}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-sm-3">
                    <AutomatchRealtors suggestedRealtors={suggestedRealtors} />
                </div>
            </div>
        );
    }
}
